// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { IgnoreReason } from "./ignore-reason";

export class IgnoreRule implements flatbuffers.IUnpackableObject<IgnoreRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IgnoreRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIgnoreRule(bb: flatbuffers.ByteBuffer, obj?: IgnoreRule): IgnoreRule {
    return (obj || new IgnoreRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIgnoreRule(bb: flatbuffers.ByteBuffer, obj?: IgnoreRule): IgnoreRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IgnoreRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  reason(): IgnoreReason {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : IgnoreReason.Unmapped;
  }

  note(): string | null;
  note(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  note(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startIgnoreRule(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addReason(builder: flatbuffers.Builder, reason: IgnoreReason) {
    builder.addFieldInt8(0, reason, IgnoreReason.Unmapped);
  }

  static addNote(builder: flatbuffers.Builder, noteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, noteOffset, 0);
  }

  static endIgnoreRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIgnoreRule(
    builder: flatbuffers.Builder,
    reason: IgnoreReason,
    noteOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    IgnoreRule.startIgnoreRule(builder);
    IgnoreRule.addReason(builder, reason);
    IgnoreRule.addNote(builder, noteOffset);
    return IgnoreRule.endIgnoreRule(builder);
  }

  unpack(): IgnoreRuleT {
    return new IgnoreRuleT(this.reason(), this.note());
  }

  unpackTo(_o: IgnoreRuleT): void {
    _o.reason = this.reason();
    _o.note = this.note();
  }

  unpackFields(...fields: string[]): IgnoreRuleT {
    const t = new IgnoreRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("reason")) {
      t.reason = this.reason();
    }
    if (fieldSet.has("note")) {
      t.note = this.note();
    }
    return t;
  }
}

export class IgnoreRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public reason: IgnoreReason = IgnoreReason.Unmapped,
    public note: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const note = this.note !== null ? builder.createString(this.note!) : 0;

    return IgnoreRule.createIgnoreRule(builder, this.reason, note);
  }

  clone(): IgnoreRuleT {
    const obj = new IgnoreRuleT();
    obj.reason = this.reason;
    obj.note = this.note;
    return obj;
  }

  equals(other: IgnoreRuleT): boolean {
    if (this.reason !== other.reason) return false;
    if (this.note !== other.note) return false;
    return true;
  }
}

export function verifyIgnoreRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
